<template>
  <v-app id="app">
    <Sidebar
      v-if="!noSidebarInThisRoutes.includes($route.name)"
      :class="`view--${$route.name}`"
    />

    <v-main :class="`view--${$route.name} ${noChat ? '' : 'hasChat'}` ">
      <router-view :key="$route.name" />
    </v-main>

    <CreateAppointment v-if="canShowClientModals" ref="createAppointmentModal" />
    <RealtyCreateUpdate v-if="canShowClientModals" ref="createUpdateRealtyModal" />
    <RechargeCreate v-if="canShowClientModals" ref="createRecharge" />
    <RealEstateUserCreateUpdate v-if="canShowClientModals" ref="createUpdateRealEstateUser" />

    <DisputeContent />

    <Toaster />
    <ModalTutorial />
    <FooterNotices />

    <HubspotChat v-if="!isAdminOrPartner && isLoggedIn" />
    <NPS v-if="!isAdminOrPartner && isLoggedIn" />
    <UserGuiding v-if="!isAdminOrPartner && isLoggedIn" />

    {{ checkUserContract() }}
  </v-app>
</template>

<script>
import Sidebar from '@/layouts/default/Sidebar'
import FooterNotices from '@/layouts/default/FooterNotices'
import Toaster from '@/components/Toaster'
import ModalTutorial from '@/components/tutorials/ModalTutorial'
import HubspotChat from '@/components/HubspotChat'
import NPS from '@/components/NPS'
import UserGuiding from '@/components/UserGuiding'

import CreateAppointment from '@/components/appointment/AppointmentCreate'
import RealtyCreateUpdate from '@/components/realty/RealtyCreateUpdate'
import RechargeCreate from '@/components/recharge/RechargeCreate.vue'
import RealEstateUserCreateUpdate from '@/components/realEstateUsers/RealEstateUserCreateUpdate'

import DisputeContent from './components/dispute/DisputeContent.vue'

import { noChatInThisRoutes, noSidebarInThisRoutes } from '@/util/helpers'

import '@/assets/styles/main.scss'

export default {
  name: 'App',

  components: {
    Sidebar,
    Toaster,
    ModalTutorial,
    FooterNotices,
    HubspotChat,
    NPS,
    UserGuiding,
    CreateAppointment,
    RealtyCreateUpdate,
    RechargeCreate,
    RealEstateUserCreateUpdate,
    DisputeContent,
  },

  computed: {
    noChat() {
      return noChatInThisRoutes.includes(this.$route.name)
    },

    isLoggedIn() {
      const token = localStorage.getItem('access_token')
      return !!token
    },

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },

    isHostAndServiceProvider() {
      const rolesStr = localStorage.getItem('access_roles') || ''
      const roles = rolesStr.split(',').map((r) => r.trim())
      return roles.includes('ROLE_HOST') && roles.includes('ROLE_SERVICE_PROVIDER')
    },

    isHost() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_HOST')
    },

    canShowClientModals() {
      return !this.isAdminOrPartner && (!this.isHost || this.isHostAndServiceProvider) && this.isLoggedIn
    }
  },

  methods: {
    // HUBSPOT MODAL
    checkUserContract() {
      const userCountry = localStorage.getItem('user_country')
      if (userCountry !== 'BR') return

      const contractStatus = localStorage.getItem('user_contract_status')
      const urlParams = document.location.search
      const currentUrlParams = this.$route.fullPath?.split('?')[1]

      const url = new URL(window.location.href)
      const pathName = url?.pathname

      if (!contractStatus) return
      if (urlParams === `?${currentUrlParams}`) return
      if (urlParams.includes('redirect=false') || urlParams.includes('contract-status=')) return
      if (pathName?.includes('/quote/') || pathName?.includes('/host-rate/') || pathName?.includes('/confirm-appointment')) return

      const currentPath = this.$route.path
      const currentQuery = { ...this.$route.query }
      currentQuery['contract-status'] = contractStatus

      this.$router.push({
        path: currentPath,
        query: currentQuery
      })
    },
  },

  data() {
    return {
      noSidebarInThisRoutes,
    }
  },
}
</script>
